var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExpedients = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    width: 21,
    height: 21,
    fill: "#fff",
    "data-name": "Capa 1",
    viewBox: "0 0 410.97 499.15",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M326.73,454.34V470.2c0,11.84-9.14,21.45-20.42,21.45H27.92C16.64,491.65,7.5,482,7.5,470.2V103.57c0-11.84,9.14-21.45,20.42-21.45h17.9",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.05,417v15.86c0,11.84-9.14,21.45-20.42,21.45H66.24c-11.28,0-20.42-9.61-20.42-21.45V66.26c0-11.85,9.14-21.45,20.42-21.45h17.9",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.37,120.05V395.58c0,11.84-9.14,21.45-20.42,21.45H104.56c-11.28,0-20.42-9.61-20.42-21.45V29c0-11.85,9.14-21.45,20.42-21.45H295.87a20,20,0,0,1,14.41,6.25l87.08,91.1A22,22,0,0,1,403.37,120.05Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,7.5h31.07c11.17,0,20.22,10.24,20.22,22.88V96.79c0,12.78,9.16,23.14,20.45,23.14h58.61c11.19,0,20.23,10.32,20.14,23l-.1,12.32",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 15
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 116.42,
    y: 113.65,
    width: 99.82,
    height: 14.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 116.42,
    y: 214.06,
    width: 256.48,
    height: 14.12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 116.42,
    y: 238.77,
    width: 256.48,
    height: 21.61
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116.42,
    y: 270.97,
    width: 256.48,
    height: 22.27
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 116.42,
    y: 331.97,
    width: 99.82,
    height: 18.16
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExpedients, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/expedients.0d9bb562.svg";
export { ForwardRef as ReactComponent };